import React from "react";
import TextField from "@material-ui/core/TextField";
import { Typography, Box } from "@material-ui/core";

export const textAreaRenderer = (
    value,
    name,
    fieldUpdateHandler,
    isError,
    mutable,
    editable,
) => {
    if (!value && typeof fieldUpdateHandler === "function" && mutable) {
        // creating data
        return (
            <Box width={"70%"}>
                <TextField
                    style={{ border: "1px solid #dddddd" }}
                    fullWidth
                    value={value || ""}
                    onChange={(e) => fieldUpdateHandler(name, e.target.value)}
                    error={!!isError}
                    helperText={isError}
                    multiline
                    minRows={1}
                    maxRows={10}
                />
            </Box>
        );
    } else if (
        value &&
        typeof fieldUpdateHandler === "function" &&
        editable !== false &&
        mutable
    ) {
        // updatig data
        return (
            <Box width={"70%"}>
                <TextField
                    fullWidth
                    value={value || ""}
                    onChange={(e) => fieldUpdateHandler(name, e.target.value)}
                    error={!!isError}
                    helperText={isError}
                    multiline
                    minRows={2}
                    maxRows={10}
                />
            </Box>
        );
    } else if (value && editable === false) {
        // view data when editable === false
        return <Typography children={value} />;
    } else if (value && !mutable) {
        // view data without editable parameter
        return <Typography children={value} />;
    } else {
        // to prevent crashes
        return [];
    }
};
